module.exports = __webpack_public_path__ + "img/corrigendum_footer.d1479943.png";